import 'regenerator-runtime/runtime.js';
import Vue from 'vue';

// Specific bootstrap JS
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Tab from 'bootstrap/js/dist/tab';
import Tooltip from 'bootstrap/js/dist/tooltip';

import { SearchClient as TypesenseSearchClient } from 'typesense';
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter/src/TypesenseInstantsearchAdapter';

// Unused:
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/toast';

const bootstrap = {
  Modal,
  Tab,
  Tooltip,
};

export {
  Vue,
  Vue as vue,
  bootstrap,
  TypesenseSearchClient,
  TypesenseInstantSearchAdapter,
};
